import { Fragment } from "react";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Label,
  Transition,
} from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";
import type { CardFilter } from "src/types/card";
import { cn } from "src/utils/cn";

type GroupVideosFilterProps = {
  selected: CardFilter;
  onChange: any;
  options: CardFilter[];
  className?: string;
};

export function GroupVideosFilter({
  selected,
  onChange,
  options,
  className,
}: GroupVideosFilterProps) {
  return (
    <div className={cn("flex", className)}>
      <Listbox value={selected} onChange={onChange}>
        {({ open }) => (
          <>
            <Label className="sr-only">Group videos filter</Label>
            <div className="relative">
              <div className="inline-flex">
                <div className="relative z-0 inline-flex">
                  <ListboxButton className="relative inline-flex items-center space-x-0.5 text-sm text-red-700">
                    <div className="font-futura text-xl font-normal text-red-700 sm:text-3xl sm:font-medium">
                      {selected.title}
                    </div>
                    <div>
                      <span className="sr-only">
                        Change group videos filter
                      </span>
                      <FiChevronDown
                        className="h-4 w-4 text-red-700 md:h-6 md:w-6"
                        aria-hidden="true"
                      />
                    </div>
                  </ListboxButton>
                </div>
              </div>

              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <ListboxOptions className="absolute z-10 mt-2 min-w-max origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-black/5 focus:outline-none sm:right-0">
                  {options.map((option) => (
                    <ListboxOption
                      key={option.title}
                      className="relative cursor-default p-4 text-sm text-gray-900 select-none"
                      value={option}
                    >
                      {({ active }) => (
                        <div className="flex flex-col">
                          <div className="flex justify-start">
                            <p
                              className={active ? `text-red-700` : `text-black`}
                            >
                              {option.title}
                            </p>
                          </div>
                        </div>
                      )}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </div>
  );
}
